module.exports = __webpack_public_path__ + "fonts/ChurchwardMarianna-Regular.8bbef587.ttf";